import type { FaireProductEntity } from "../../entity_types/product";

export const p_w36z66nwt2: FaireProductEntity = {
  token: "p_w36z66nwt2",
  type: "product",
  name: "Handcrafted Baguette Pet Toy | Sustainable | Chew Toy",
  brandToken: "b_htr5r9hpc5",
  brandName: "Monli Handcrafted Pet Toys",
  imageUrl: "https://cdn.faire.com/fastly/4ec9b1f9611251a4f5664d519919623f7258b3b75905a71bb01c466825db7dfa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46a6089190874a64facb0bd4783c7d0db97e66debf67276b09c6845607a72647.jpeg",
    "https://cdn.faire.com/fastly/822af1b2eb665dcaf63f9ada744bfc1c049a3986a7e1e31af393f71d75c2eb1f.jpeg",
    "https://cdn.faire.com/fastly/8fd6c3769c49d6068b6302778b666015bdf1b014737d004032f42741272aa4ce.jpeg",
    "https://cdn.faire.com/fastly/5ed983ab295b3910156ceecfda6e4d801f0f9902d37d0476ecf6eeefcb7b372f.jpeg"
  ],
  priceDollars: 6,
  description: "Introducing Monli’s Café & Market Collection — our newest 2026 release designed to bring a little extra joy (and style!) to playtime. Inspired by cozy mornings, fresh bakery finds, this series blends charm, craftsmanship, and natural textures in a way only Monli can.\n\nEach piece is handcrafted from our signature upcycled cotton rope — gentle on teeth, durable for daily play, and beautiful enough to display in any modern pet-friendly home.\n\n• The Baguette Tug: (9.06\" × 2.36\", Weight 4.2 oz)\n\nA soft, durable rope baguette perfect for small and medium dogs who love gentle tug or fetch. Lightweight, stylish, and irresistibly playful.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:07:00.521Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
